import React from 'react';
import PropTypes from 'prop-types';
import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';
import PrettyLink from 'gatsby-core-theme/src/components/atoms/pretty-link';
import OperatorCta from 'gatsby-core-theme/src/components/atoms/button/operator-cta';
import Tnc from 'gatsby-core-theme/src/components/molecules/tnc';
import { TrackingKeys } from '~constants/tracking-api';
import OperatorDetail from '../../../operator-details';

import styles from './row.module.scss';

const Variable = ({
  toplist,
  tracker,
  oneliner,
  pageTemplate,
  moduleName = TrackingKeys?.HEADER?.TOPLIST,
}) => {
  let { items } = toplist;

  items = items?.filter((res) => res.status === 'active');

  const itemsToShow = items?.slice(0, 3);

  const itemNode = itemsToShow?.map((item, index) => {
    const { ribbons } = item;
    const hasRibbon = ribbons && ribbons.length > 0;
    const onelinerMain = item?.bonuses[oneliner]?.one_liner;

    return (
      <li
        className={`${styles.li || ''} ${hasRibbon ? styles.hasRibbonIncluded : ''}`}
        data-rank={index + 1}
      >
        <OperatorDetail
          imageLoad="eager"
          item={item}
          showAuthor={false}
          showRibbon={false}
          imageWidth={96}
          imageHeight={96}
          template={pageTemplate}
          showReviewLink={false}
          moduleName={moduleName}
          itemPosition={index + 1}
          useTextRating
          ratingIcon={
            <LazyImage
              src="/images/star.svg"
              alt="Star Icon"
              loading="eager"
              width={17}
              height={17}
              className={styles.status}
            />
          }
        />
        <div className={styles?.bonusModule}>
          <PrettyLink
            operator={item}
            tracker={tracker}
            pageTemplate={pageTemplate}
            moduleName={moduleName}
            clickedElement="oneliner"
            itemPosition={index + 1}
          >
            <p className={styles.oneLinerMain}>{onelinerMain}</p>
          </PrettyLink>
          <span className={styles?.ctaAndReview || ''}>
            <OperatorCta
              operator={item}
              tracker={tracker}
              moduleName={moduleName}
              pageTemplate={pageTemplate}
              gtmClass="toplist-operator-cta-gtm"
              buttonSize="m"
              buttonType="primary"
              titleSuffix={item.name}
              itemPosition={index + 1}
            />
            {/* The url us getting from the hercules because each operator has different link */}
            {item?.extra_fields?.terms_and_condition_link_text && (
              <a
                href={item?.extra_fields?.terms_and_condition_link_text}
                target="_blank"
                rel="noopener noreferrer"
              >
                +18 T&C Apply
              </a>
            )}
          </span>
        </div>
        <div className={styles.tnc}>
          <Tnc isFixed operator={item} />
        </div>
        {hasRibbon && <span className={styles.ribbon}>{ribbons[0]}</span>}
      </li>
    );
  });
  return <>{itemNode}</>;
};

Variable.propTypes = {
  moduleName: PropTypes.string,
  toplist: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  tracker: PropTypes.string,
  oneliner: PropTypes.string,
  pageTemplate: PropTypes.string,
};

export default Variable;
